import { Component } from '@angular/core';
import { Router } from "@angular/router";
import { AbstractComponent } from "../abstract-component/abstract.component";
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-authentication',
    templateUrl: './authentication.component.html',
    styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent extends AbstractComponent {

    constructor(private router: Router) {
        super();
    }

    ngOnInit() {
        if (!environment.need_authentication) {
            this.router.navigate(['lang', 'fr', 'project-type-choice']);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/authentication/authentication.component.ts